import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';

@Injectable({
  providedIn: 'root',
})
export class KeyboardService {
    constructor() {
        if (Capacitor.isNativePlatform()) {
            this.initKeyboardListeners();
        }
    }

  initKeyboardListeners() {
    Keyboard.addListener('keyboardWillShow', (info: any) => {
        document.body.classList.add('keyboard-visible');
        document.body.style.setProperty('--keyboard-height', `${info.keyboardHeight}px`);

      // Scroll focused input into view
      const activeElement = document.activeElement as HTMLElement;
      if (activeElement && ['INPUT', 'TEXTAREA'].includes(activeElement.tagName)) {
        setTimeout(() => {
          activeElement.scrollIntoView({ behavior: 'auto', block: 'nearest' });
        }, 0);
      }
    });

    Keyboard.addListener('keyboardWillHide', () => {
      document.body.classList.remove('keyboard-visible');
      document.body.style.setProperty('--keyboard-height', '0px');
    });
  }
}
